import styled from 'styled-components';

/* Sits wholly inside its own cell: half outside, the next header cell
   painted over it and left a 4px target. */
export const ResizeHandle = styled.span`
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  width: 10px;
  cursor: col-resize;
  z-index: 1;
  touch-action: none;

  &::after {
    content: '';
    position: absolute;
    top: 30%;
    bottom: 30%;
    right: 0;
    width: 1px;
    border-radius: 1px;
    background: currentColor;
    /* Always faintly shown, so people can tell a column can be resized. */
    opacity: 0.2;
    transition: opacity 0.15s;
  }

  &:hover::after,
  &:active::after {
    opacity: 0.6;
  }
`;
